import Navbar from '../home/components/Navbar';
import Hero from './components/Hero';
import Content from './components/Content';
import FAQ from './components/FAQ';
import Footer from '../home/components/Footer';
import { useSchemaOrg, usePageMeta } from '../../utils/seo';

export default function GrandPianoRemovalLondon() {
  // Set page meta tags
  usePageMeta(
    'Grand Piano Removal London | Baby Grand & Concert Grand Specialists',
    'Expert grand piano removal in London. Baby grand from £320, concert grand from £550. Full disassembly, specialist equipment, £5M insured. Free quote — 020 3441 9463.',
    'grand piano removal London, grand piano movers London, baby grand piano removal, concert grand piano movers',
    'https://www.pianomovers.co.uk/grand-piano-removal-london',
    'Grand Piano Removal London | Baby Grand & Concert Grand Specialists',
    'Expert grand piano removal in London. Baby grand from £320, concert grand from £550. Full disassembly, specialist equipment, £5M insured. Free quote — 020 3441 9463.',
    'Grand Piano Removal London | Baby Grand & Concert Grand',
    'Expert grand piano removal London. Baby grand from £320, concert grand from £550. Specialist equipment, £5M insured. Free quote — 020 3441 9463.'
  );

  // Add FAQ structured data
  useSchemaOrg({
    type: 'FAQPage',
    data: {
      mainEntity: [
        {
          '@type': 'Question',
          name: 'Can a grand piano be moved up stairs in London?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Yes, grand pianos can be moved up stairs in London by specialist piano movers. The process involves removing the legs and pedal lyre to reduce weight and dimensions, then carefully manoeuvring the piano body on a specialist piano board. For particularly challenging staircases with tight turns or limited headroom, external crane lifts may be required. Professional grand piano movers in London have the equipment and expertise to assess your specific staircase and determine the safest approach.',
          },
        },
        {
          '@type': 'Question',
          name: 'Does a grand piano need to be tuned after moving?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Yes, grand pianos typically require tuning 2-3 weeks after being moved. The moving process, changes in environment, and settling into a new location can affect the tension of the piano\'s strings. Professional piano movers recommend waiting this period to allow the instrument to acclimatise to its new environment before tuning. Many specialist grand piano removal companies in London can recommend experienced piano tuners or offer tuning services as part of their comprehensive moving package.',
          },
        },
        {
          '@type': 'Question',
          name: 'How long does a grand piano removal in London take?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'A typical grand piano removal in London takes 3-5 hours for local moves within the same borough. This includes time for disassembling the legs and pedal lyre, protective wrapping, loading, transportation, unloading, and reassembly. More complex moves involving multiple flights of stairs, difficult access, or longer distances across London may take 5-8 hours. Concert grand piano removals generally require more time due to their size and weight. Your specialist will provide an accurate time estimate during the initial survey.',
          },
        },
      ],
    },
  });

  return (
    <div className="bg-[#f5f5f0] text-[#1a1916]">
      <Navbar />
      <Hero />
      <Content />
      <FAQ />
      <div className="bg-[#1a1916] py-4 text-center">
        <p className="text-[#d4d4ce] text-xs">
          Piano Movers UK is an independent guide to piano removal services in London.
        </p>
      </div>
      <Footer />
    </div>
  );
}